import '../../styles/index.scss';

import React, { ReactElement, ReactNode } from 'react';
import Head from 'next/head';
import { NextPage } from 'next';
import { AppProps } from 'next/app';
import { appWithTranslation, useTranslation } from 'next-i18next';
import ToasterProvider, { IAppToaster } from 'ap-admin-components/lib/Components/Toaster';
import { OverlaysProvider } from 'ap-admin-components/lib/Components/Overlays';
import { translationNamespace } from '@/lib/config';

export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

// Create Toaster root
// https://github.com/palantir/blueprint/issues/5212
export let AppToaster: IAppToaster;

const App = ({ Component, pageProps }: AppPropsWithLayout) => {
  const { t } = useTranslation(translationNamespace);
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <React.Fragment>
      <ToasterProvider
        instance={(instance) => {
          AppToaster = instance;
        }}
      />
      <Head>
        <title>{t('title')}</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />
        <meta
          name="msapplication-TileImage"
          content="/favicons/mstile-144x144.png"
        />
        <meta
          name="theme-color"
          content="#103045"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />
      </Head>
      <OverlaysProvider>{getLayout(<Component {...pageProps} />)}</OverlaysProvider>
    </React.Fragment>
  );
};

export default appWithTranslation(App);
